var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    {
      attrs: {
        "invalid-feedback": _vm.invalidFeedback,
        label: _vm.label,
        "label-for": _vm.formControlId,
      },
    },
    [
      _vm.selectAllButtons
        ? _c("div", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.selectAll.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n            alle auswählen\n        ")]
            ),
            _vm._v("\n        /\n        "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.deselectAll.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n            alle abwählen\n        ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("b-form-checkbox-group", {
        attrs: {
          id: _vm.formControlId,
          buttons: _vm.buttons,
          disabled: _vm.isReadOnlyProperty,
          name: _vm.formControlId,
          options: _vm.options,
          required: _vm.isRequiredProperty,
          stacked: _vm.stacked,
          state: _vm.validationState,
          switches: _vm.asSwitch,
        },
        on: { change: _vm.emitChange },
        model: {
          value: _vm.data[_vm.property],
          callback: function ($$v) {
            _vm.$set(_vm.data, _vm.property, $$v)
          },
          expression: "data[property]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }